
import { Component, inject, OnInit, signal, DestroyRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

import reportSentryError from '../helpers/reportSentryError';

import { ApiService, Region } from './api/api.service';
import { AuthService } from './auth/auth.service';
import { LayoutComponent } from './components/layout/layout.component';
import { LoaderComponent } from './components/loader/loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent, LayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly apiService = inject(ApiService);
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);
  isUserAuthorized = this.authService.isUserAuthorized;

  constructor(private readonly route: ActivatedRoute) {}

  isReady = signal(false);
  ngOnInit() {
    const region = this.route.snapshot.queryParamMap.get('region');

    this.apiService.setRegion((region as Region) || Region.EU);

    if (!this.authService.isAuthFlow()) {
      this.authService.checkIfUserAuthorized().subscribe(() => {});
    }

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe({
      next: () => {
        let route = this.router.routerState.snapshot.root;
        let lang: string | null;

        while (route.firstChild) {
          route = route.firstChild;
        }

        lang = route.params['lang'];

        if (lang) {
          this.translate.use(lang);
        } else {
          this.router.navigate(['/en/profile']);
        }
      },
      error: (error) => {
        reportSentryError({
          error,
          customErrorName: 'App Component Navigation Error',
        });
      },
    });

    this.isReady.set(true);
  }
}
